import questionReader from '../store/readHelpers/QuestionReader';
import visitedQuestionsReader from '../store/readHelpers/VisitedQuestionsReader';
import settingsReader from '../store/readHelpers/SettingsReader';
import tocReader from '../store/readHelpers/TocReader';
import storeManager from '../store/StoreManager';
import progressActions from '../actions/ProgressActions';
import assessmentReader from '../store/readHelpers/AssessmentReader';
import responseReader from '../store/readHelpers/ResponseReader';
import sessionReader from '../store/readHelpers/SessionReader';

const progressBarService = {
    /**
     * Gets the current value of the progress bar.
     *
     * @returns {int}
     */
    getCurrentProgressValue() {
        if (settingsReader.isCatTestType()) {
            return (100 / questionReader.getTotalNumberOfQuestions()) * visitedQuestionsReader.getNumberOfVisitedQuestion();
        }

        if (sessionReader.isParentTest()) {
            const questionIds = this.getNumberOfQuestionsInCurrentTest();
            const respondedQuestionsIds = this.getRespondedQuestionsIds();
            const responsesInCurrentTest = questionIds.filter(element => respondedQuestionsIds.includes(element));

            return (100 / questionIds.length) * responsesInCurrentTest.length;
        }

        return (100 / questionReader.getTotalNumberOfQuestions()) * responseReader.getTotalNumberOfResponses();
    },

    /**
     * Gets an array of all questions ids from all sections in current test, sorted in order.
     *
     * @returns {Array}
     */
    getNumberOfQuestionsInCurrentTest() {
        const { assessment } = storeManager.getState();
        return assessmentReader.getQuestionsIndex(assessment).itemsOrder.map(question => question.contentRevisionId);
    },

    /**
     * Gets an array of all  responded questions ids from all sections in current test, sorted in order.
     *
     * @returns {Array}
     */

    getRespondedQuestionsIds() {
        const state = storeManager.getState();
        return responseReader.getResponses(state).map(response => response.identifier);
    },

    updateProgressValue() {
        if (settingsReader.isProgressBarQuestionsEnabled() && !tocReader.isTocPage()) {
            const store = storeManager.getStore();
            store.dispatch(
                progressActions.setFooterProgressBarValue(progressBarService.getCurrentProgressValue())
            );
        }
    },
};

export default progressBarService;
